import { useState } from 'react'
import clsx from 'clsx'
import {
  Button,
  Card,
  Col,
  Divider,
  Input,
  Modal,
  Row,
  Select,
  Space,
  Tag,
  Text,
  Title,
} from 'components/common'
import * as styles from '../styles.module.css'

export interface CustomerTagsCardProps {
  tagTitle?: string
  onCancel?: () => void
}

export const CustomerTagsCard = ({
  tagTitle,
}: CustomerTagsCardProps): JSX.Element => {
  // Tag Modal Start
  const [showTagModal, setShowTagModal] = useState(false)
  // Tag Modal end

  return (
    <>
      <Card shadow>
        <div>
          <Row className={clsx(styles.commonPaddingBottom)}>
            <Col span={12}>
              <Title level={5}>タグ</Title>
            </Col>

            <Col span={12} className={clsx('flex', 'flex-end', 'justify-end')}>
              <Button
                type={'link'}
                style={{ padding: 0, top: 0 }}
                onClick={() => {
                  setShowTagModal(true)
                }}
              >
                すべてのタグを表示する
              </Button>
              <Modal
                title={'タグ'}
                visible={showTagModal}
                width={700}
                onCancel={() => {
                  setShowTagModal(false)
                }}
                footer={
                  <Space>
                    <Button
                      key="back"
                      onClick={() => {
                        setShowTagModal(false)
                      }}
                    >
                      キャンセル
                    </Button>
                    <Button
                      type={'primary'}
                      onClick={() => {
                        setShowTagModal(false)
                      }}
                    >
                      保存する
                    </Button>
                  </Space>
                }
              >
                <div>
                  <Col span={24}>
                    <Col span={24} className={clsx(styles.commonPaddingBottom)}>
                      <Text>適用されているタグ</Text>
                    </Col>
                    <Row style={{}}>
                      {new Array(5).fill(null).map(() => (
                        <Tag closable>VIP</Tag>
                      ))}
                    </Row>
                    <Divider />
                  </Col>
                  <Col span={24}>
                    <Col span={24}>
                      <div
                        className={clsx(
                          'flex',
                          'justify-between',
                          'items-center'
                        )}
                      >
                        <Text style={{ top: 0 }}>全てのタグ</Text>
                        <div
                          className={clsx(
                            'flex',
                            'flex-auto',
                            'item-top',
                            'justify-end'
                          )}
                        >
                          <Text type="secondary">並び替え：</Text>
                          <Select
                            defaultValue="latestUpdate"
                            className={clsx('justify-end', 'ml-2')}
                          >
                            <Select.Option value="latestUpdate">
                              <Text type="secondary">アルファベット順</Text>
                            </Select.Option>
                          </Select>
                        </div>
                      </div>
                    </Col>

                    <Row>
                      {new Array(5).fill(null).map(() => (
                        <Tag>VIP</Tag>
                      ))}
                    </Row>
                  </Col>
                </div>
              </Modal>
            </Col>
          </Row>
          <Col className={clsx(styles.commonPaddingBottom)}>
            <Input size="large" placeholder="リピーターなど" />
          </Col>

          <Row>
            {/* Customers Tags */}
            {new Array(4).fill(null).map(() => (
              <Tag
                closable
                onClose={() => {
                  return null
                }}
              >
                VIP
              </Tag>
            ))}
          </Row>
        </div>
      </Card>
    </>
  )
}
